module.exports = __webpack_public_path__ + "static/img/8.64c8805.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/eng/8.png
// module id = 1O0k
// module chunks = 0